//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

/**
 * React-dnd requires us to give all all items in our drag and drop systems
 * an item type to ensure that items can only be dropped on drop targets that
 * are designed to handle them. This is the global enum to ensure that these
 * are kept unique.
 */
export enum DndItemType {
  // Calendar
  CalendarFeedPreviewItem = 'CALENDAR_FEED_PREVIEW_ITEM',
  CalendarMonthViewItem = 'CALENDAR_MONTH_VIEW_ITEM',
  CalendarWeekViewItem = 'CALENDAR_WEEK_VIEW_ITEM',

  // Email Builder
  EmailBuilderImage = 'EMAIL_BUILDER_IMAGE',

  // Galleries
  PinnedMediaImage = 'PINNED_MEDIA_IMAGE',

  // Instagram
  InstagramScheduleFeedPreviewItem = 'INSTAGRAM_SCHEDULE_FEED_PREVIEW_ITEM',
  InstagramScheduleWeekViewItem = 'INSTAGRAM_SCHEDULE_WEEK_VIEW_ITEM',
  InstagramScheduleMonthViewItem = 'INSTAGRAM_SCHEDULE_MONTH_VIEW_ITEM',
  PostDetailsDraggableTag = 'IGPD_DRAGGABLE_TAG',
  PostDetailsDraggableThumbnail = 'IGPD_DRAGGABLE_THUMBNAIL',

  // Like2Buy
  Like2BuyPinnedMedia = 'LIKE2BUY_PINNED_MEDIA',
  Like2BuyV2PinnedMedia = 'LIKE2BUY_V2_PINNED_MEDIA',

  // Pinterest
  PinterestBulkScheduleThumbnail = 'PINTEREST_BULK_SCHEDULE_THUMBNAIL',

  // UIA
  UIAProductTag = 'UIA_PRODUCT_TAG',
}

export enum DnDTagSubType {
  User = 'User',
  Product = 'Product',
}
